import React from 'react';
import { usePermissions } from '../../hooks/usePermissions';
import AccessDenied from './AccessDenied';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredPermission: string;
  fallbackMessage?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiredPermission,
  fallbackMessage
}) => {
  const { hasPermission, error } = usePermissions();

  if (!hasPermission(requiredPermission)) {
    return <AccessDenied message={error || fallbackMessage} />;
  }

  return <>{children}</>;
};

export default ProtectedRoute; 